import axios from "axios";
import Api from "@/services/api";

export default {
  install(Vue) {
    Vue.prototype.$ipCheck = {
      // Function to get the client's IP address
      async getClientIP() {
        try {
          const response = await axios.get("https://api.ipify.org?format=json");
          return response.data.ip;
        } catch (err) {
          console.error("getClientIP error:", err);
          return null;
        }
      },

      // Async function to check if client IP is within allowed ranges
      async ipRangeCheck(clientIP) {
        try {
          const { data } = await Api.get("/allowlists", {
            headers: {
              "X-Client-IP": clientIP
            },
          });
          return data.allowed;
        } catch (err) {
          console.error("ipRangeCheck error:", err);
          return false;
        }
      },
      async checkRegistrationAllowed(recaptcha_token) {
        try {
          const { data } = await Api.get("/allowed-ips/check", {
            headers: {
              "X-Captcha-Token": recaptcha_token,
            },
          });
          return data.allowed;
        } catch (err) {
          console.error("checkRegistrationAllowed error:", err);
          return false;
        }
      }
    };
  }
};
